(() => {
  angular
    .module('app.campaign')
    .controller('PrefixErrorModalController', PrefixErrorModal);

  PrefixErrorModal.$inject = ['companyCodes', 'close'];
  function PrefixErrorModal(companyCodes, close) {
    var vm = this;

    vm.selectedPrefix = null;
    vm.cCodes = companyCodes;

    vm.selectPrefix = function (prefix) {
      vm.selectedPrefix = prefix;
      return false;
    };

    vm.close = function () {
      close(vm.selectedPrefix);
    }
  }

  angular
    .module('app.campaign')
    .controller('TcodeErrorModalController', TcodeErrorModal);

  TcodeErrorModal.$inject = ['close', 'cid', 'tailcode'];
  function TcodeErrorModal(close, cid, tailcode) {
    var vm = this;

    vm.newCid = cid;
    vm.newTailcode = tailcode;

    vm.close = function () {
      close(vm.newCid,vm.newTailcode);
    }
  }


  angular
    .module('app.campaign')
    .controller('EventTypeErrorModalController', EventTypeErrorModal);

  EventTypeErrorModal.$inject = ['close'];
  function EventTypeErrorModal(close) {
    var vm = this;

    vm.selectedEventType = null;
    vm.eventTypes = ['impression', 'click', 'iv-supported', 'iv-inview', 'videostart', 'videocomplete'];

    vm.selectEventType = function (eventType) {
      vm.selectedEventType = eventType;
      return false;
    };

    vm.close = function () {
      close(vm.selectedEventType);
    }
  }



  angular
    .module('app.campaign')
    .controller('NameErrorModalController', NameErrorModal);

  NameErrorModal.$inject = ['$sce', 'close', 'type', 'name'];
  function NameErrorModal($sce, close, type, name) {
    var vm = this;
    var text;

    vm.type = type;
    vm.newName = name;
    text = '<h2>';

    switch (type) {
      case 'total':
        text += "The following reserved word(s) are not valid as tracking point names: 'Total'";
        break;
      default:
        text += `
        Tracking point name may only contain the following: <kbd>a-z</kbd>, <kbd>A-Z</kbd>, numbers, spaces,
        and the following special characters: <kbd>(),.+-=_/|!#$%&amp;</kbd>`;
    }

    text += '</h2>';

    vm.renderHtml = function () {
      return $sce.trustAsHtml(text);
    };

    vm.close = function () {
      close(vm.newName);
    }
  }

})();
